export default {
  home: {
    title: 'Inicio',
    aiBannerTxt: {
      title: 'Hacer realidad la educación en IA',
      subtitle: 'Empoderamiento digital de la IA+ Educación, integrando conceptos innovadores',
      description: 'Enfoque en productos y servicios técnicos personalizados con láser, ayudando a instituciones y empresas a integrar "AI+ Education"'
    },
    description: 'Bienvenido a nuestro sitio web de marketing en Vue.js',
    banner: {
      slide1: {
        title:
          'Kits STEAM | Kits de Inteligencia Artificial | Kits de Corte Láser',
        description:
          'Ofrecemos soluciones innovadoras de educación STEAM y diversos kits para familias, educadores y distribuidores, diseñados especialmente para niños de 3 a 16 años.',
      },
      slide2: {
        title: 'Kits profesionales diseñados para la creatividad de los niños',
        description:
          'Cursos, equipos y software integrados para facilitar el aprendizaje basado en proyectos',
      },
      slide3: {
        title: 'Educación tecnológica orientada al futuro',
        description:
          'Práctica manual e integración interdisciplinaria para desarrollar la resolución de problemas y la capacidad de colaboración',
      },
    },
    factory: {
      banner: {
        alt: 'Banner de fábrica inteligente',
        title: 'Soluciones de fábrica inteligente',
        description:
          'Construcción de líneas de producción | Sensores industriales | Control PLC y adquisición de datos',
        image: 'https://picsum.photos/seed/factory-banner/1000/600',
      },
      resourcesTitle: 'Recursos educativos',
      resources: [
        {
          title: 'Materiales de enseñanza basados en proyectos',
          desc: 'Presentaciones PPT del curso, apuntes, diseño de actividades en clase y recomendaciones de evaluación.',
          image: 'https://picsum.photos/seed/factory-res-1/374/217',
        },
        {
          title: 'Ejemplos de escenarios y materiales',
          desc: 'Ejemplos y fragmentos de código de control de cintas transportadoras, detección de estaciones y vinculación de equipos.',
          image: 'https://picsum.photos/seed/factory-res-2/374/217',
        },
        {
          title: 'Tareas de ampliación después de clase',
          desc: 'Tareas extendidas y sugerencias de aplicación interdisciplinaria para fomentar la exploración y la creación.',
          image: 'https://picsum.photos/seed/factory-res-3/374/217',
        },
      ],
      intro: {
        title: 'Introducción del producto',
        desc: 'La solución de fábrica inteligente se centra en la construcción de líneas de producción y el control por programación, abarcando sensores industriales, identificación de estaciones, control PLC/microcontroladores y adquisición de datos, con énfasis en la práctica y la formación sistemática.',
        bg: 'https://picsum.photos/seed/factory-bg/1200/736',
      },
      course: {
        title: 'Cursos complementarios',
        desc: 'Cursos basados en proyectos diseñados en torno a la construcción de líneas de producción, sensores industriales, control PLC y adquisición de datos, con énfasis en la práctica y la formación sistemática.',
        image: 'https://picsum.photos/seed/factory-course/668/597',
      },
      equipments: [
        {
          title: 'Módulo de cinta transportadora',
          image: 'https://picsum.photos/seed/factory-eq-1/209/209',
        },
        {
          title: 'Sensor fotoeléctrico',
          image: 'https://picsum.photos/seed/factory-eq-2/209/209',
        },
        {
          title: 'Unidad de control PLC',
          image: 'https://picsum.photos/seed/factory-eq-3/209/209',
        },
        {
          title: 'Módulo de brazo robótico',
          image: 'https://picsum.photos/seed/factory-eq-4/209/209',
        },
        {
          title: 'Módulo de reconocimiento de códigos de barras',
          image: 'https://picsum.photos/seed/factory-eq-5/209/209',
        },
        {
          title: 'Sensor de temperatura y humedad',
          image: 'https://picsum.photos/seed/factory-eq-6/209/209',
        },
        {
          title: 'Módulo de accionamiento de motor',
          image: 'https://picsum.photos/seed/factory-eq-7/209/209',
        },
        {
          title: 'Módulo de detección de estaciones',
          image: 'https://picsum.photos/seed/factory-eq-8/209/209',
        },
        {
          title: 'Módulo de parada de emergencia de seguridad',
          image: 'https://picsum.photos/seed/factory-eq-9/209/209',
        },
        {
          title: 'Gateway de adquisición de datos',
          image: 'https://picsum.photos/seed/factory-eq-10/209/209',
        },
      ],
    },
    solutions: {
      title: 'Soluciones educativas STEAM de Zetok',
      learnMore: 'Más información >',
      items: [
        {
          image: require('@/assets/home/solution1.webp'),
          title: 'Kits Zetok',
          description:
            'A través de la práctica y el aprendizaje basado en proyectos, se desarrollan el pensamiento innovador y las habilidades prácticas.',
          link: '/solutions/kits',
        },
        {
          image: require('@/assets/home/solution2.webp'),
          title: 'Cortadora y grabadora láser Good Laser',
          description:
            'Las cortadoras láser aportan una nueva experiencia de aprendizaje práctico a la educación STEAM',
          link: '/solutions/laser',
        },
      ],
    },
    scenes: {
      title: 'Escenarios de enseñanza',
      items: [
        {
          image: require('@/assets/home/education1.webp'),
          title: 'Soluciones educativas STEM',
        },
        {
          image: require('@/assets/home/education2.webp'),
          title: 'Soluciones de espacio maker',
        },
      ],
    },
    aiBanner: {
      alt: 'Banner de IA',
      image: require('@/assets/home/aibanner.png'),
    },
    kitsSection: {
      alt: 'Kits Zetok',
      title: 'Kits de Inteligencia Artificial',
      description:
        'Los kits de inteligencia artificial suelen incluir abundantes proyectos interactivos y prácticos que despiertan el interés y la curiosidad de los estudiantes por la tecnología.',
      image: require('@/assets/home/kitsbanner.png'),
    },
    kitsCarousel: {
      alt: 'Carrusel de kits',
      title: 'Potenciar el pensamiento innovador',
      items: [
        { image: require('@/assets/home/kits1.png') },
        { image: require('@/assets/home/kits2.png') },
        { image: require('@/assets/home/kits3.png') },
        { image: require('@/assets/home/kits4.png') },
        { image: require('@/assets/home/kits5.png') },
        { image: require('@/assets/home/kits6.png') },
        { image: require('@/assets/home/kits7.png') },
        { image: require('@/assets/home/kits8.png') },
        { image: require('@/assets/home/kits9.png') },
      ],
    },
    products: {
      title: 'Kits Zetok y cortadoras láser Good Laser',
      tabs: {
        kits: 'Kits',
        courses: 'Cursos',
        laser: 'Equipos láser',
        software: 'Software',
      },
      items: {
        kits: [
          {
            image: require('@/assets/home/product1.webp'),
            title: 'Kit de iniciación al corte láser',
            description: '(Incluye consumibles de tableros de madera)',
          },
          {
            image: require('@/assets/home/product2.webp'),
            title: 'Caja mágica de ciencia',
            description: '(Incluye tableros de madera + kit de microcircuitos)',
          },
          {
            image: require('@/assets/home/product3.webp'),
            title: 'Kit de programación de inteligencia artificial',
            description: '',
          },
        ],
        courses: [
          {
            image: require('@/assets/home/product4.webp'),
            title: 'Sistema de exploración científica – Infantil',
            description: '(6 cursos)',
          },
          {
            image: require('@/assets/home/product5.webp'),
            title: 'Sistema maker STEAM para adolescentes',
            description: '(3 cursos)',
          },
          {
            image: require('@/assets/home/product6.webp'),
            title: 'Curso de corte láser',
            description: '(3 cursos)',
          },
          {
            image: require('@/assets/home/product7.webp'),
            title: 'Sistema de cursos de inteligencia artificial',
            description: '(4 cursos)',
          },
        ],
        laser: [
          {
            image: require('@/assets/home/product8.png'),
            title: 'Light 530 ',
            description: 'Cortadora y grabadora láser CO₂ de sobremesa de 55W',
          },
          {
            image: require('@/assets/home/product9.png'),
            title: 'Light 640',
            description: 'Cortadora y grabadora láser profesional de sobremesa',
          },
          {
            image: require('@/assets/home/product10.png'),
            title: 'Light Blue 530 ',
            description:
              'Cortadora y grabadora láser de luz azul inteligente de sobremesa',
          },
          {
            image: require('@/assets/home/product11.png'),
            title: 'Mark M20',
            description: 'Marcadora láser de alta precisión',
          },
        ],
        software: [
          {
            image: require('@/assets/home/product12.png'),
            title: 'Plataforma de aprendizaje Zetok',
            description: '',
          },
          {
            image: require('@/assets/home/product13.png'),
            title: 'Plataforma en la nube Zetok',
            description: '',
          },
          {
            image: require('@/assets/home/product14.png'),
            title: 'Light Maker',
            description: '',
          },
          {
            image: require('@/assets/home/product15.png'),
            title: 'mind+',
            description: '',
          },
          {
            image: require('@/assets/home/product16.png'),
            title: 'Arduino',
            description: '',
          },
        ],
      },
    },
  },
  switch_lang: 'English',
  nav: {
    products: 'Productos',
    smartFarm: 'Granja inteligente',
    smartHome: 'Hogar inteligente',
    smartTraffic: 'Tráfico inteligente',
    smartFactory: 'Fábrica inteligente',
    laserSteam: 'Kit STEAM de corte láser',
    dreamScience: 'Kit Ciencia del Sueño',
    course: 'Cursos',
    device: 'Dispositivos',
    education: 'Soluciones educativas',
    stem: 'Soluciones educativas STEM',
    maker: 'Soluciones de espacio maker',
    software: 'Software',
    service: 'Servicios y soporte',
    afterSale: 'Descarga de tutoriales',
    about: 'Sobre nosotros',
    aboutUs: 'Sobre nosotros',
    dealer: 'Conviértase en nuestro distribuidor',
    cooperation: 'Uso de productos y cooperación educativa',
    news: 'Noticias',
    coursesSeries: 'Cuatro grandes series de cursos',
    viewMore: 'Ver más',
    store: 'Tienda'
  },
  globalContactForm: {
    title: 'Contáctenos',
    subtitle:
      'Si tiene cualquier pregunta o necesidad, no dude en contactarnos. Estaremos encantados de atenderle',
    fields: {
      name: 'Nombre',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      company: 'Empresa',
      message: 'Mensaje',
    },
    placeholders: {
      name: 'Por favor, introduzca su nombre',
      email: 'Por favor, introduzca su dirección de correo electrónico',
      phone: 'Por favor, introduzca su número de teléfono',
      company: 'Por favor, introduzca el nombre de su empresa',
      message: 'Por favor, escriba su necesidad o consulta',
    },
    validation: {
      name: 'Por favor, introduzca su nombre',
      email: 'Por favor, introduzca su correo electrónico',
      emailFormat: 'El formato del correo electrónico no es correcto',
      phone: 'Por favor, introduzca su número de teléfono',
      message: 'Por favor, introduzca el mensaje',
    },
    submit: 'Enviar',
    submitting: 'Enviando…',
    visual: {
      title: 'Servicio profesional',
      description:
        'Enfocados en la educación de la creatividad tecnológica para niños de 3 a 16 años, con espacios maker y desarrollo de productos y cursos relacionados.',
    },
    contact: {
      phone: 'Línea de servicio',
      email: 'Correo electrónico',
    },
  },
  thankYou: {
    metaTitle: 'Gracias',
    title: '¡Gracias por tu envío!',
    description:
      'Hemos recibido tu información y nos pondremos en contacto lo antes posible.',
    seoDescription:
      'Envío recibido. Nuestro equipo se pondrá en contacto en breve.',
    backHome: 'Volver al inicio',
    browseProducts: 'Explorar productos',
    contactSupport: 'Contactar soporte',
    nextStepsTitle: 'Qué ocurre a continuación',
    nextSteps: [
      'Nuestro equipo revisará tu solicitud en 1–2 días hábiles.',
      'Si es necesario, nos pondremos en contacto para obtener más detalles.',
      'Puedes seguir explorando o contactarnos por teléfono o correo.',
    ],
    contactTitle: '¿Necesitas ayuda inmediata?',
    contactPhoneLabel: 'Teléfono de atención:',
    contactEmailLabel: 'Correo electrónico:',
  },
  about: {
    banner: {
      alt: 'Banner sobre nosotros',
      title:
        'Zetok se enfoca en la educación innovadora y ofrece kits y cursos de alta calidad',
      image: require('@/assets/about/banner.png'),
    },
    mission: {
      title: 'Nuestra misión',
      desc: 'Nuestra misión es empoderar la educación a través de tecnologías avanzadas de inteligencia artificial, inspirar la innovación y formar a los futuros líderes e innovadores. Creemos que proporcionar herramientas y soluciones educativas de alta calidad puede ayudar a estudiantes y educadores a desarrollar su máximo potencial.',
      image: require('@/assets/about/mission.png'),
    },
    vision: {
      title: 'Nuestra visión',
      desc: 'La tecnología empodera la educación, ayudando a cada estudiante a acceder a recursos STEM de alta calidad, despertar su potencial y formar a los futuros innovadores y líderes.',
      image: require('@/assets/about/vision.png'),
    },
    products: {
      title: 'Nuestros productos',
      tabs: ['Kits', 'Cursos', 'Equipos láser'],
      items: [
        {
          title: 'Kits',
          desc: 'Ofrecemos una amplia variedad de kits STEM, que incluyen inteligencia artificial, robótica, programación y experimentos científicos, diseñados cuidadosamente, fáciles de usar y adecuados para estudiantes de diferentes edades.',
          image: require('@/assets/about/kits.png'),
        },
        {
          title: 'Cursos',
          desc: 'Nuestros cursos están diseñados por expertos en educación para combinarse con los kits y ofrecer una experiencia de aprendizaje integral, desde conceptos básicos hasta aplicaciones avanzadas, adecuados para distintos niveles.',
          image: require('@/assets/about/courses.png'),
        },
        {
          title: 'Equipos láser',
          desc: 'Nuestros equipos de corte y grabado láser están diseñados especialmente para entornos educativos: son seguros, precisos y fáciles de operar, y brindan a los estudiantes la oportunidad de convertir sus ideas en obras físicas.',
          image: require('@/assets/about/laser.png'),
        },
      ],
    },
    dealer: {
      banner: {
        alt: 'Únase a nosotros como distribuidor de Zetok',
        title: 'Únase a nosotros como distribuidor de Zetok',
        image: require('@/assets/about/dealer.png'),
      },
      intro: {
        title:
          '¡Desarrolle nuevas oportunidades educativas y comparta los frutos de la innovación!',
        desc: 'Zetok le invita a explorar nuevas vías de la educación STEM, ofreciendo kits de IA, equipos láser, etc., para inspirar la creatividad de los estudiantes. ¡Le invitamos a unirse para ganar juntos el futuro!',
        image: require('@/assets/about/dealer1.png'),
      },
      mission: {
        title: 'Nuestra misión',
        items: [
          {
            title: 'Productos líderes',
            desc: 'Acceso a herramientas educativas STEAM de alta calidad en el mercado.',
            image: require('@/assets/about/dealer-mission-1.png'),
          },
          {
            title: 'Altos beneficios',
            desc: 'Disfrute de descuentos competitivos e incentivos de ventas.',
            image: require('@/assets/about/dealer-mission-2.png'),
          },
          {
            title: 'Soporte de mercado',
            desc: 'Proporcionamos materiales de marketing y formación en ventas para ayudarle a abrir rápidamente el mercado.',
            image: require('@/assets/about/dealer-mission-3.png'),
          },
          {
            title: 'Cooperación de marca',
            desc: 'Colabore con Zetok para compartir la influencia de la marca y los recursos del mercado.',
            image: require('@/assets/about/dealer-mission-4.png'),
          },
        ],
      },
    },
    cooperation: {
      banner: {
        alt: 'Banner de cooperación',
        title: 'Cooperación de productos',
        cta: 'Contactar ahora',
        ctaLink: '/about#contact',
        image: require('@/assets/about/coop-introbanner.png'),
      },
      intro: {
        title: 'Despertar el potencial de los futuros científicos e ingenieros',
        desc: 'Únase a nuestro programa de promoción de la educación STEM y obtenga ofertas especiales y pruebas de producto diseñadas para educadores. Proporcionamos herramientas STEM innovadoras para el aula, así como descuentos exclusivos, para ayudarle a formar a la próxima generación de innovadores y solucionadores de problemas.',
        image: require('@/assets/about/coop-introbanner1.png'),
      },
      stem: {
        title: '¡Actúe ahora y abra un nuevo capítulo en la educación STEM!',
        items: [
          {
            title: 'Prueba gratuita de productos',
            desc: 'Permite experimentar nuestras herramientas antes de comprarlas.',
            image: require('@/assets/about/edu1.png'),
          },
          {
            title: 'Descuentos exclusivos',
            desc: 'Ofrecemos soluciones STEM económicas para sus aulas o escuelas.',
            image: require('@/assets/about/edu2.png'),
          },
          {
            title: 'Recursos educativos',
            desc: 'Proporcionamos abundantes recursos didácticos y planes de estudio para apoyar sus actividades educativas.',
            image: require('@/assets/about/edu3.png'),
          },
        ],
      },
      contact: {
        title: 'Contáctenos',
        desc: 'Si tiene cualquier pregunta o necesidad, no dude en contactarnos. Estaremos encantados de atenderle',
        image: require('@/assets/about/kites.png'),
      },
    },
    news: {
      banner: {
        alt: 'Banner del centro de noticias',
        title: 'Centro de noticias',
        image: require('@/assets/about/newsbanner.png'),
      },
      title: 'Centro de noticias',
      tabs: [
        { key: 'company', label: 'Noticias de la empresa' },
        { key: 'industry', label: 'Noticias del sector' },
        { key: 'expo', label: 'Noticias de exposiciones' },
      ],
      data: {
        company: [
          {
            id: 'company-1',
            title: 'Zhongze lanza un nuevo kit de IA para el aula',
            date: '2025-04-22',
            image: 'https://picsum.photos/seed/news-company-1-zh/560/342',
          },
          {
            id: 'company-2',
            title: 'Cooperación piloto de proyectos STEM con escuelas locales',
            date: '2025-04-15',
            image: 'https://picsum.photos/seed/news-company-2-zh/560/342',
          },
          {
            id: 'company-3',
            title:
              'Actualización de software mejora la experiencia de gestión en el aula',
            date: '2025-03-30',
            image: 'https://picsum.photos/seed/news-company-3-zh/560/342',
          },
          {
            id: 'company-4',
            title: 'Organización de talleres de formación para docentes',
            date: '2025-03-18',
            image: 'https://picsum.photos/seed/news-company-4-zh/560/342',
          },
          {
            id: 'company-5',
            title: 'La red de distribuidores se expande a más regiones',
            date: '2025-03-02',
            image: 'https://picsum.photos/seed/news-company-5-zh/560/342',
          },
          {
            id: 'company-6',
            title: 'La nueva serie de cursos se centra en proyectos reales',
            date: '2025-02-20',
            image: 'https://picsum.photos/seed/news-company-6-zh/560/342',
          },
          {
            id: 'company-7',
            title: 'El resumen anual destaca los logros en innovación',
            date: '2025-02-05',
            image: 'https://picsum.photos/seed/news-company-7-zh/560/342',
          },
          {
            id: 'company-8',
            title:
              'El programa de bienestar comunitario lleva STEM a los jóvenes',
            date: '2025-01-25',
            image: 'https://picsum.photos/seed/news-company-8-zh/560/342',
          },
        ],
        industry: [
          {
            id: 'industry-1',
            title:
              'Tendencia global: aplicación del aprendizaje basado en proyectos en STEM',
            date: '2025-04-10',
            image: 'https://picsum.photos/seed/news-industry-1-zh/560/342',
          },
          {
            id: 'industry-2',
            title: 'La IA en la educación: mejores prácticas emergentes',
            date: '2025-03-25',
            image: 'https://picsum.photos/seed/news-industry-2-zh/560/342',
          },
          {
            id: 'industry-3',
            title:
              'Los nuevos estándares curriculares enfatizan más la capacidad práctica',
            date: '2025-03-12',
            image: 'https://picsum.photos/seed/news-industry-3-zh/560/342',
          },
          {
            id: 'industry-4',
            title:
              'El hardware educativo se adapta mejor a las necesidades del aula',
            date: '2025-02-28',
            image: 'https://picsum.photos/seed/news-industry-4-zh/560/342',
          },
          {
            id: 'industry-5',
            title:
              'Los proyectos STEAM continúan avanzando en distintos distritos',
            date: '2025-02-14',
            image: 'https://picsum.photos/seed/news-industry-5-zh/560/342',
          },
          {
            id: 'industry-6',
            title:
              'Los proyectos de desarrollo sostenible llegan a las aulas STEM',
            date: '2025-01-30',
            image: 'https://picsum.photos/seed/news-industry-6-zh/560/342',
          },
          {
            id: 'industry-7',
            title:
              'Los espacios maker influyen en las formas de aprendizaje innovador',
            date: '2025-01-16',
            image: 'https://picsum.photos/seed/news-industry-7-zh/560/342',
          },
        ],
        expo: [
          {
            id: 'expo-1',
            title: 'Zhongze participa en la feria de tecnología educativa',
            date: '2025-04-05',
            image: 'https://picsum.photos/seed/news-expo-1-zh/560/342',
          },
          {
            id: 'expo-2',
            title:
              'Exhibición de proyectos estudiantiles en la exposición regional',
            date: '2025-03-22',
            image: 'https://picsum.photos/seed/news-expo-2-zh/560/342',
          },
          {
            id: 'expo-3',
            title:
              'Demostraciones interactivas en eventos maker atraen la atención',
            date: '2025-03-08',
            image: 'https://picsum.photos/seed/news-expo-3-zh/560/342',
          },
          {
            id: 'expo-4',
            title: 'Taller de programación visual orientado a docentes',
            date: '2025-02-21',
            image: 'https://picsum.photos/seed/news-expo-4-zh/560/342',
          },
          {
            id: 'expo-5',
            title: 'Nuevos equipos presentados a socios educativos',
            date: '2025-02-09',
            image: 'https://picsum.photos/seed/news-expo-5-zh/560/342',
          },
        ],
      },
    },
  },

  finance: {
    contact: {
      success:
        'Envío exitoso, nos pondremos en contacto con usted lo antes posible',
      error: 'Error en el envío, por favor inténtelo de nuevo más tarde',
      networkError:
        'Error de red, por favor verifique su conexión e inténtelo de nuevo',
    },
  },
  footer: {
    subscribePlaceholder:
      'Su número de teléfono y dirección de correo electrónico',
    subscribe: 'Suscribirse',
    subscribeSuccess: 'Suscripción exitosa',
    contact: {
      sales: 'Línea de ventas: +86 18379276683',
      service: 'Línea de servicio: +86 400 968 0598',
      email: 'Correo electrónico: sam@zz-steam.com',
      address:
        'Dirección: Edificio Huashengda, Torre A, Calle Bagua Cuarta, Distrito de Futian, Shenzhen',
    },
    icp: 'Política de Privacidad · Acuerdo de Usuario Derechos de autor © Zhongze Education (Shenzhen) Co., Ltd. Número ICP de Guangdong 2024289240-3',
  },
  solutions: {
    stem: {
      banner: {
        alt: 'Banner de la solución educativa STEM',
        title: ' Liderando la creatividad en la educación STEM',
        description:
          'Orientado a K12, nos enfocamos en la educación creativa STEM para despertar la curiosidad, desarrollar la lógica y encender la pasión por la programación.',
        image: require('@/assets/solution/banner.png'),
      },
      intro: {
        title: 'Educación en inteligencia artificial y programación',
        items: [
          {
            icon: require('@/assets/solution/icon1.png'),
            title: 'Fácil de aprender y usar',
            description:
              'Programación gráfica, comienzo inmediato para principiantes, creación sencilla de proyectos de IA personalizados.',
          },
          {
            icon: require('@/assets/solution/icon2.png'),
            title: 'Potentes funciones',
            description:
              'Hardware inteligente, interacción por voz, creatividad sin límites.',
          },
          {
            icon: require('@/assets/solution/icon3.png'),
            title: 'Gran escalabilidad',
            description:
              'Conexión de componentes de hardware, activa la imaginación, crea sin límites.',
          },
          {
            icon: require('@/assets/solution/icon4.png'),
            title: 'Cursos abundantes',
            description:
              'Cursos complementarios, desde la base hasta la práctica, ayudan a los estudiantes a construir un sistema de conocimientos.',
          },
        ],
      },
      scenes: {
        title: 'Conozca nuestros cursos destacados',
        items: [
          {
            tab: 'Educación escolar',
            title: 'Educación escolar con IA',
            desc: 'Utilizando kits de inteligencia artificial para crear asistentes de voz inteligentes, se despierta el interés a través de la práctica, se desarrollan la lógica y las habilidades de programación, y se experimenta el encanto de la IA.',
            image: require('@/assets/solution/tc1.png'),
          },
          {
            tab: 'Formación para competencias',
            title: 'Formación para competencias',
            desc: 'Los kits inteligentes impulsan las competencias de robótica y la innovación tecnológica; los estudiantes diseñan obras inteligentes y mejoran la colaboración y la capacidad innovadora.',
            image: require('@/assets/solution/tc2.png'),
          },
          {
            tab: 'Aprendizaje en el hogar',
            title: 'Aprendizaje en el hogar',
            desc: 'Aprendizaje de proyectos de inteligencia artificial en familia, desarrollo de la habilidad práctica, fortalecimiento de las relaciones y mejora de la alfabetización tecnológica.',
            image: require('@/assets/solution/tc3.png'),
          },
        ],
      },
      split: {
        title:
          'IA + Educación: inaugurando una nueva era del aprendizaje inteligente',
        desc: 'Mediante el uso de tecnología de inteligencia artificial, rutas de aprendizaje personalizadas y enseñanza precisa, cada estudiante puede aprender libremente en el océano del conocimiento.',
        image: require('@/assets/solution/banner1.png'),
      },
      kits: {
        title: 'Kits de la serie STEM',
        images: [
          require('@/assets/solution/kits1.png'),
          require('@/assets/solution/kits2.png'),
          require('@/assets/solution/kits3.png'),
          require('@/assets/solution/kits4.png'),
        ],
      },
    },
    makerSpace: {
      banner: {
        alt: 'Banner de la solución de espacio maker',
        title: 'Explore nuestro espacio maker',
        description:
          'En el espacio maker, la educación se combina con la tecnología innovadora para ofrecer a los estudiantes una plataforma de práctica y exploración',
        image: require('@/assets/solution/spacebanner.png'),
      },
      intro: {
        title: 'Habilidades maker integrales',
        items: [
          {
            icon: require('@/assets/solution/icon5.png'),
            title: 'Aplicación de herramientas tecnológicas',
            desc: 'Programación gráfica, fácil de comenzar, los principiantes pueden crear proyectos de inteligencia artificial en segundos',
          },
          {
            icon: require('@/assets/solution/icon6.png'),
            title: 'Apertura y flexibilidad',
            desc: 'Espacio maker, exploración libre, un paraíso exclusivo para desatar la creatividad.',
          },
          {
            icon: require('@/assets/solution/icon7.png'),
            title: 'Práctica manual',
            desc: 'Práctica manual, fabricación, experimentación, exploración, inicio del viaje de aprendizaje.',
          },
          {
            icon: require('@/assets/solution/icon8.png'),
            title: 'Aprendizaje colaborativo',
            desc: 'Fomenta la cooperación en equipo y desarrolla habilidades de trabajo en equipo y comunicación.',
          },
        ],
      },
      scenes: {
        title: 'Escenarios de aplicación del espacio maker',
        items: [
          {
            tab: 'Cursos manuales escolares',
            title: 'Cursos manuales escolares',
            desc: 'Como complemento sólido para cursos de manualidades y diseño artístico.',
            image: require('@/assets/solution/tc4.png'),
          },
          {
            tab: 'Clubes de investigación y práctica creativa',
            title: 'Clubes de investigación y práctica creativa',
            desc: 'Proporciona una plataforma de práctica para los clubes de innovación de las escuelas',
            image: require('@/assets/solution/tc5.png'),
          },
          {
            tab: 'Laboratorios educativos',
            title: 'Laboratorios educativos',
            desc: 'Adecuado para escuelas, universidades o laboratorios, actualiza el entorno de aprendizaje y proporciona cortadoras láser profesionales a los estudiantes.',
            image: require('@/assets/solution/tc6.png'),
          },
        ],
      },
      split: {
        title: 'Herramientas para hacer realidad la creatividad',
        desc: 'Gracias a la capacidad de corte preciso de las cortadoras láser y a la interacción inteligente de los robots programables, los estudiantes pueden transformar ideas abstractas en obras físicas concretas',
        image: require('@/assets/solution/banner2.png'),
      },
      kits: {
        title: 'Kits de la serie maker',
        images: [
          require('@/assets/solution/kits5.png'),
          require('@/assets/solution/kits6.png'),
          require('@/assets/solution/kits7.png'),
          require('@/assets/solution/kits8.png'),
        ],
      },
    },
  },
  software: {
    banner: {
      alt: 'Banner de la página de software',
      title: 'Centro de Software Zetok',
      image: require('@/assets/software/banner.png'),
    },
    download: {
      title: 'Descarga de software',
      items: [
        {
          key: 'lightmaker-app',
          icon: 'https://picsum.photos/seed/sw-app-1/88/88',
          name: 'Light maker App',
          buttonText: 'Descargar versión móvil',
          link: '#',
        },
        {
          key: 'goodlaser-lightmaker',
          icon: 'https://picsum.photos/seed/sw-app-2/88/88',
          name: 'Good-laser Light maker',
          buttonText: 'Descargar versión de escritorio',
          link: '#',
        },
        {
          key: 'zz-learning-app',
          icon: 'https://picsum.photos/seed/sw-app-3/88/88',
          name: 'Aplicación de la plataforma de aprendizaje Zhongze',
          buttonText: 'Descargar versión móvil',
          link: '#',
        },
        {
          key: 'zz-learning-platform',
          icon: 'https://picsum.photos/seed/sw-app-4/88/88',
          name: 'Plataforma de aprendizaje Zhongze Technology',
          buttonText: 'Descargar versión de escritorio',
          link: '#',
        },
      ],
    },
    intro: {
      'goodlaser-lightmaker': {
        header: {
          title: ' Software exclusivo para equipos láser Light Maker',
          desc: 'Integra diseño gráfico y control de equipos, ahorra mucho tiempo al usuario y ofrece una solución integral de diseño y control láser.',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-1/514/403',
            title: 'Sistema de diseño potente y fácil de usar',
            desc: 'Potente software de creación, compatible con formatos JPG, DXF, AI, DST, PNG, BMP, TIF, SVG de alta calidad. DWG, DXF, AI, DST, PNG, BMP, TIF, SVG, etc.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-2/514/403',
            title: 'Profesionalismo',
            desc: 'Funciones profesionales de dibujo que cubren todas las necesidades de producción. Ya sea diseño complejo o corte simple, todo se puede manejar con facilidad.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-3/514/403',
            title: 'Fácil de operar',
            desc: 'Cuenta con una interfaz fácil de usar y es compatible con múltiples equipos láser. Ofrece facilidad de uso, interfaz multifuncional y capacidades eficientes de corte y grabado.',
          },
        ],
      },
      'lightmaker-app': {
        header: {
          title: 'Plataforma en la nube Zetok',
          desc: 'La plataforma en la nube es una herramienta innovadora de gestión educativa, diseñada para ofrecer una solución integral para docentes, estudiantes y escuelas. A través de nuestra plataforma, puede gestionar fácilmente la entrega de tareas, el monitoreo de equipos, los reportes de reparación y la configuración de parámetros.',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-app-1/514/403',
            title: 'Operación conveniente',
            desc: 'Creación con un solo clic: biblioteca integrada y configuración de parámetros, compatible con creación con un solo clic, simplificando el proceso de operación. Monitoreo de equipos: supervisa el estado de los equipos en tiempo real para asegurar el desarrollo fluido de las actividades educativas.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-app-2/514/403',
            title: 'Gestión unificada',
            desc: 'Conexión en paralelo de equipos: admite la conexión en paralelo con otros equipos del aula maker, gestión con un solo clic para mejorar la eficiencia administrativa.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-app-3/514/403',
            title: 'Monitoreo en tiempo real',
            desc: 'Estado del equipo: conozca en tiempo real el estado de funcionamiento y reporte fallas de inmediato. Mantenimiento: el sistema recuerda periódicamente el mantenimiento según el tiempo de operación y la frecuencia de uso, prolonga la vida útil del equipo y mejora la calidad de corte.',
          },
        ],
      },
      'zz-learning-app': {
        header: {
          title:
            'Introducción al software de la aplicación de la plataforma de aprendizaje Zhongze',
          desc: 'Plataforma móvil que ofrece cursos, prácticas y evaluaciones para los estudiantes; texto de referencia provisional, se podrá reemplazar posteriormente.',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-app-1/514/403',
            title: 'Inteligente y conveniente, ideal para principiantes',
            desc: 'Cuenta con una rica biblioteca de recursos y parámetros preestablecidos, compatible con creación con un solo clic para un inicio rápido. Guía detallada para principiantes en el móvil que facilita el aprendizaje. El servicio en la nube permite el monitoreo en tiempo real del estado de los equipos del aula para garantizar un proceso educativo seguro y eficiente.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-app-2/514/403',
            title: 'Creación con IA',
            desc: 'La creación con un solo clic y la generación de imágenes con IA simplifican el proceso de diseño y aumentan la eficiencia creativa. El usuario solo necesita introducir instrucciones simples o cargar imágenes de referencia, y la IA genera automáticamente materiales de alta calidad listos para el corte.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-app-3/514/403',
            title: 'Nueva experiencia de aprendizaje eficiente',
            desc: 'La plataforma de aprendizaje Zetok integra aprendizaje de cursos, diseño gráfico y procesamiento por corte láser en un solo sistema, con operación simple e intuitiva. La página de inicio utiliza un diseño en tarjetas que distingue claramente los módulos, logrando una integración perfecta entre aprendizaje, diseño y procesamiento, y mejorando significativamente la eficiencia del aprendizaje.',
          },
        ],
      },
      'zz-learning-platform': {
        header: {
          title:
            'Introducción al software de la plataforma de aprendizaje Zhongze Technology',
          desc: 'Ofrece gestión de cursos, asignación de tareas y análisis de evaluaciones en una plataforma integral; texto de referencia provisional, el contenido detallado podrá completarse posteriormente.',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-web-1/514/403',
            title: 'Gestión y publicación de cursos',
            desc: 'Gestión centralizada de contenidos y recursos educativos, compatible con múltiples tipos de materiales y formatos.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-web-2/514/403',
            title: 'Análisis de datos del aula',
            desc: 'Visualización de datos de aprendizaje y resultados de evaluación para apoyar la toma de decisiones educativas.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-web-3/514/403',
            title: 'Colaboración multiplataforma',
            desc: 'Trabajo colaborativo con la App y los dispositivos, conectando el aula con la práctica.',
          },
        ],
      },
    },
  },

  product: {
    farm: {
      banner: {
        alt: 'Banner de granja inteligente',
        title: 'Kit de aprendizaje de granja inteligente',
        btnText: 'Comprar ahora',
        description:
          'Aprendizaje basado en proyectos | Programación + Hardware + IA | Apto para primaria y secundaria',
        image: require('@/assets/product/farm/banner.png'),
      },
      sections: {
        courseTitle: 'Contenido del curso por proyectos',
        resourceTitle: 'Recursos didácticos',
        equipmentsTitle: 'Configuración de equipos',
      },
      courses: [
        {
          bg: '#FBBC05',
          txt: '#fff',
          title: 'Contenido del curso variado y completo',
          desc: '12 lecciones de nivel básico a avanzado: desde la detección de temperatura hasta el riego y control de temperatura inteligentes, todo en un solo recorrido.',
          image: require('@/assets/product/farm/education1.png'),
        },
        {
          bg: '#4285F4',
          txt: '#fff',
          title: 'Integración de conocimientos multidisciplinarios',
          desc: 'Cada proyecto abarca programación, hardware electrónico, estructuras mecánicas y otras disciplinas, ayudando a los estudiantes a aplicar de forma integral lo aprendido y a desarrollar el pensamiento interdisciplinario.',
          image: require('@/assets/product/farm/education2.png'),
        },
        {
          bg: '#EA4335',
          txt: '#fff',
          title: 'Temática basada en la vida cotidiana',
          desc: 'Con la granja inteligente como tema, cercana a la vida de los estudiantes, es fácil despertar su interés y entusiasmo por participar.',
          image: require('@/assets/product/farm/education3.png'),
        },
      ],
      resources: [
        {
          title: 'PPT y guías didácticas completas',
          desc: 'PPT y guías para 16 clases, estrechamente alineados con los proyectos de enseñanza, que brindan abundante material a los docentes y reducen la carga de preparación.',
          image: require('@/assets/product/farm/edu1.png'),
        },
        {
          title: 'Videos de ensamblaje de cursos por proyectos',
          desc: 'Los materiales en video muestran de forma visual el proceso de construcción de los proyectos, ayudando a los estudiantes a comprender mejor los pasos y a mejorar la eficiencia de aprendizaje.',
          image: require('@/assets/product/farm/edu2.png'),
        },
        {
          title: 'Materiales didácticos de apoyo',
          desc: 'Guías y otros materiales complementarios ofrecen una orientación de estudio más detallada, facilitando la revisión y el autoaprendizaje después de clase.',
          image: require('@/assets/product/farm/edu3.png'),
        },
      ],
      equipments: [
        {
          title: 'Tira de luces RGB',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'Módulo de reloj DS1307',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'Sensor de temperatura y humedad DHT11',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'Sensor de movimiento humano',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'Módulo de iluminación LED',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'Módulo de ventilador',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'Interruptor optoacoplador tipo ranura',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'Módulo de botón',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'Placa de control',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'Placa de expansión',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },
    home: {
      banner: {
        alt: 'Kit de aprendizaje para hogar inteligente',
        title: 'Kit de aprendizaje para hogar inteligente',
        btnText: 'Comprar ahora',
        description:
          'Introducción a la programación y la IA | Aprendizaje por proyectos | Primera opción para aulas tecnológicas de primaria y secundaria',
        image: require('@/assets/product/home/banner.png'),
      },
      resourcesTitle: 'Ventajas del kit de iniciación al hogar inteligente',
      resources: [
        {
          title: 'Recursos abundantes',
          desc: 'Proporciona recursos didácticos completos para facilitar la enseñanza de los profesores y el aprendizaje de los estudiantes.',
          image: require('@/assets/product/home/adv1.png'),
        },
        {
          title: 'Integración multidisciplinaria',
          desc: 'Cada proyecto abarca programación, hardware electrónico, estructuras mecánicas y otras disciplinas, ayudando a los estudiantes a aplicar lo aprendido de forma integral y a desarrollar el pensamiento interdisciplinario.',
          image: require('@/assets/product/home/adv2.png'),
        },
        {
          title: 'Tareas de ampliación después de clase',
          desc: 'Tareas extendidas y sugerencias de aplicación interdisciplinaria para fomentar la exploración y la creación.',
          image: require('@/assets/product/home/adv3.png'),
        },
      ],
      course: {
        title: 'Cursos complementarios',
        desc: 'Incluye 12 cursos de proyectos de alta calidad, que abarcan múltiples aspectos del hogar inteligente, como timbre electrónico, luz regulable en la entrada, garaje con sensor, control de acceso con contraseña, alerta de gas, alarma antirrobo, luces de colores, luz ambiental con música, detección de luz diurna, detección de temperatura ambiente y ventilador con control térmico, entre otros.',
        image: require('@/assets/product/home/banner2.png'),
      },
      scenesTitle: 'Múltiples escenarios de aplicación',
      scenes: [
        {
          title: 'Enseñanza en el aula',
          image: require('@/assets/product/home/c1.png'),
        },
        {
          title: 'Desarrollo creativo independiente',
          image: require('@/assets/product/home/c2.png'),
        },
        {
          title: 'Interacción familiar entre padres e hijos',
          image: require('@/assets/product/home/c3.png'),
        },
        {
          title: 'Exhibición de actividades',
          image: require('@/assets/product/home/c4.png'),
        },
      ],
      equipmentsTitle: 'Configuración de equipos',
      equipments: [
        {
          title: 'Tira de luces RGB',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'Módulo de reloj DS1307',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'Sensor de temperatura y humedad DHT11',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'Sensor de movimiento humano',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'Módulo de iluminación LED',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'Módulo de ventilador',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'Interruptor optoacoplador tipo ranura',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'Módulo de botón',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'Placa de control',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'Placa de expansión',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },
    factory: {
      banner: {
        alt: 'Banner de fábrica inteligente',
        title: 'Kit de aprendizaje de fábrica inteligente',
        btnText: 'Comprar ahora',
        description: ` · Cobertura completa de sensores / control / accionamiento <br>
 · Simulación de línea de producción real<br>
 · Formación de “ingenieros del futuro”`,
        image: require('@/assets/product/factory/banner.png'),
      },
      resourcesTitle: 'Características del producto',
      resources: [
        {
          title: 'Experiencia central de la Industria 4.0',
          desc: 'Los estudiantes practican sensores, control, accionamiento y gestión de datos en una línea de producción simulada.',
          image: require('@/assets/product/factory/tc1.png'),
        },
        {
          title: 'Aprendizaje basado en proyectos',
          desc: 'Incluye tutoriales de programación y 12 cursos con PPT para facilitar el aprendizaje del usuario.',
          image: require('@/assets/product/factory/tc2.png'),
        },
        {
          title: 'Simulación de escenarios reales',
          desc: 'Brazo robótico inteligente, sistema de clasificación automática y almacén inteligente para simular la gestión logística y de inventarios, iniciando el viaje práctico STEM.',
          image: require('@/assets/product/factory/tc3.png'),
        },
      ],
      intro: {
        title: 'Introducción del producto',
        desc: 'El kit de aprendizaje de fábrica inteligente es un conjunto didáctico basado en proyectos que integra programación, hardware electrónico, estructuras mecánicas, corte láser y divulgación de inteligencia artificial, adecuado para uso y enseñanza en primaria y secundaria. Con el tema “Fabricación inteligente · Creando el futuro”, mediante la simulación de entornos de producción, se desarrollan las capacidades de investigación científica, diseño de ingeniería, control de programación e innovación colaborativa de los estudiantes.',
        bg: require('@/assets/product/factory/product.png'),
      },
      course: {
        title: 'Cursos complementarios',
        desc: '12 cursos de alta calidad: abarcan la introducción a la fábrica inteligente, el conocimiento de los procesos de producción, la aplicación de sensores, los fundamentos del accionamiento mecánico, la construcción de sistemas de transporte, la clasificación automática, el control colaborativo de estaciones de trabajo, el montaje de brazos robóticos, la clasificación inteligente, entre otros. Los cursos están diseñados por proyectos sobre control y adquisición de datos, enfatizando la práctica y el entrenamiento sistemático.',
        image: require('@/assets/product/factory/course.png'),
      },
      equipmentsTitle: 'Configuración de equipos',
      equipments: [
        {
          title: 'Tira de luces RGB',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'Módulo de reloj DS1307',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'Sensor de temperatura y humedad DHT11',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'Sensor de movimiento humano',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'Módulo de iluminación LED',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'Módulo de ventilador',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'Interruptor optoacoplador tipo ranura',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'Módulo de botón',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'Placa de control',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'Placa de expansión',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },
    kits: {
      laserSteam: {
        banner: {
          alt: 'Banner del kit STEAM de corte láser',
          title: 'Kit STEAM de corte láser',
          btnText: 'Comprar ahora',
          description:
            'Solución integral de educación en fabricación inteligente para desarrollar el pensamiento innovador y el trabajo en equipo',
          image: require('@/assets/product/laser-steam/banner.png'),
        },
        resourcesTitle: 'Ventajas del kit STEAM de corte láser',
        resources: [
          {
            title: 'Teoría de las inteligencias múltiples',
            desc: 'Basado en la teoría de las inteligencias múltiples, el curso desarrolla la creatividad, el pensamiento crítico, la resolución de problemas y la comunicación colaborativa.',
            image: require('@/assets/product/laser-steam/adv1.png'),
          },
          {
            title: 'Aprendizaje basado en proyectos',
            desc: 'A través del aprendizaje por proyectos, los estudiantes aprenden en la práctica, mejorando la eficiencia y el interés por el aprendizaje.',
            image: require('@/assets/product/laser-steam/adv2.png'),
          },
          {
            title: 'Educación STEAM',
            desc: 'El contenido del curso integra ciencia, tecnología, ingeniería, arte y matemáticas, ayudando a los estudiantes a establecer un pensamiento interdisciplinario.',
            image: require('@/assets/product/laser-steam/adv3.png'),
          },
        ],
        teach: {
          title: 'Enseñanza detallada complementaria',
          tabs: [
            { key: 'cutter', label: 'Cortadora láser' },
            { key: 'lesson', label: 'Cursos complementarios' },
            { key: 'material', label: 'Material didáctico' },
            { key: 'software', label: 'Software' },
          ],
          images: {
            cutter: require('@/assets/product/laser-steam/cutter.png'),
            lesson: require('@/assets/product/laser-steam/lesson.png'),
            material: require('@/assets/product/laser-steam/material.png'),
            software: require('@/assets/product/laser-steam/software.png'),
          },
        },
        aiBanner: {
          title: 'Educación de IA, inicio inteligente',
          desc: 'Integrar la educación STEAM con elementos de IA para crear una experiencia de aprendizaje integral.',
        },
        equipmentsTitle: 'Configuración de equipos',
      },
      // Kit de Ciencia de los Sueños (Dream Science Kit)
      dreamScience: {
        banner: {
          alt: 'Banner del kit de ciencia de los sueños',
          title: 'Caja Mágica de Ciencia (Kit de Ciencia de los Sueños)',
          description:
            'Conceptos científicos básicos | Pensamiento científico | Práctica de investigación | Actitud y responsabilidad',
          image: require('@/assets/product/dream-science/banner.png'),
        },
        resourcesTitle: 'Contenido del kit',
        resources: [
          {
            title: 'Materiales para experimentos científicos',
            desc: 'Se utilizan para completar diversos experimentos y proyectos científicos.',
            image: require('@/assets/product/dream-science/kits1.png'),
          },
          {
            title: 'Recursos didácticos',
            desc: 'Incluyen PPT y guías didácticas, que apoyan un semestre completo de actividades educativas, estrechamente alineadas con los proyectos y los puntos de conocimiento.',
            image: require('@/assets/product/dream-science/kits2.png'),
          },
          {
            title: 'Videos y guías de ensamblaje',
            desc: 'Materiales didácticos de apoyo que ayudan a los estudiantes a comprender y dominar mejor los pasos de operación.',
            image: require('@/assets/product/dream-science/kits3.png'),
          },
        ],
        objectivesTitle: 'Objetivos didácticos',
        objectives: [
          {
            title: 'Capacidad de investigación científica',
            desc: 'Plantear preguntas, elaborar planes, recopilar y analizar datos',
            image: require('@/assets/product/dream-science/education1.png'),
          },
          {
            title: 'Capacidad de práctica en ingeniería',
            desc: 'Construcción y pruebas prácticas, mejora iterativa de los planes',
            image: require('@/assets/product/dream-science/education2.png'),
          },
          {
            title: 'Integración interdisciplinaria',
            desc: 'Combinar matemáticas, física y arte para completar proyectos',
            image: require('@/assets/product/dream-science/education3.png'),
          },
        ],
        intro: {
          title: 'Público objetivo',
          description:
            'Estudiantes de primaria y secundaria: adecuado para estudiantes de diferentes edades, ayuda a mejorar su alfabetización científica y capacidad práctica. Docentes: proporciona recursos y orientación didáctica para ayudarles a llevar a cabo mejor sus actividades de enseñanza.',
          image: require('@/assets/product/dream-science/banner1.png'),
          alt: 'Imagen de la sección de introducción',
        },
      },
    },

    // 查看所有套件页面
    kitsViewAll: {
      banner: {
        alt: 'Ver todos los kits - Banner',
        title: 'Serie de kits',
        image: require('@/assets/product/kitsall/banner.png'),
      },
      contentTitle:
        'Con proyectos como núcleo, los estudiantes desarrollan la capacidad de aplicar de manera integral sus conocimientos para resolver problemas mediante la realización de distintas tareas por proyectos.',
      moreText: 'Más información',
      items: [
        {
          image: require('@/assets/product/kitsall/kits1.png'),
          title: 'Kit de aprendizaje de granja inteligente',
          desc: 'Con proyectos como eje, estimula la creatividad y la capacidad práctica de los estudiantes, y desarrolla habilidades para resolver problemas reales.',
          link: '/products/laser-steam',
        },
        {
          image: require('@/assets/product/kitsall/kits2-1.png'),
          title: 'Kit de aprendizaje de hogar inteligente',
          desc: 'Integra programación, hardware electrónico, estructuras mecánicas, corte láser e introducción a la inteligencia artificial, ofreciendo una experiencia de aprendizaje integral.',
          link: '/products/dream-science',
        },
        {
          image: require('@/assets/product/kitsall/kits2-2.png'),
          title: 'Kit de aprendizaje de transporte inteligente',
          desc: 'Un kit de enseñanza basado en proyectos que integra programación, hardware electrónico, estructuras mecánicas, corte láser e introducción a la inteligencia artificial.',
          link: '/products',
        },
        {
          image: require('@/assets/product/kitsall/kits2-3.png'),
          title: 'Kit de aprendizaje de fábrica inteligente',
          desc: 'Abarca conocimientos básicos de inteligencia artificial y casos prácticos, guiando progresivamente a los estudiantes y ayudándolos a construir de forma sistemática su sistema de conocimientos.',
          link: '/products/traffic',
        },
        // {
        //   image: require('@/assets/product/kitsall/kits2.png'),
        //   title: 'Kit STEAM de corte láser',
        //   desc: 'El kit de cursos STEAM de corte láser se basa en la teoría de las inteligencias múltiples, el concepto de educación STEAM y la teoría del aprendizaje basado en proyectos.',
        //   link: '/products/home',
        // },
        // {
        //   image: require('@/assets/product/kitsall/kits2.png'),
        //   title: 'Kit Ciencia de los Sueños',
        //   desc: 'El kit Ciencia de los Sueños puede satisfacer las necesidades de diferentes etapas de aprendizaje, estimulando el interés científico y el espíritu exploratorio de los estudiantes.',
        //   link: '/products/farm',
        // },
      ],
    },
    traffic: {
      banner: {
        alt: 'Banner de transporte inteligente',
        title: 'Kit de aprendizaje de transporte inteligente',
        btnText: 'Comprar ahora',
        description: `12 cursos basados en proyectos 
<br>· Programación dual gráfica/Python  <br>
· Simulación de escenarios reales<br>
· Listo para usar y enseñar`,
        image: require('@/assets/product/traffic/banner.png'),
      },
      resourcesTitle: 'Características del producto',
      resources: [
        {
          title: 'Investigación científica e innovación',
          desc: 'Los estudiantes construyen sistemas de transporte inteligente utilizando módulos electrónicos y estructuras mecánicas',
          image: require('@/assets/product/traffic/traffic1.png'),
        },
        {
          title: 'Alto valor educativo',
          desc: 'Permite construir proyectos como farolas inteligentes, semáforos, pasos peatonales y estacionamientos, ayudando a los estudiantes a comprender el concepto de transporte inteligente.',
          image: require('@/assets/product/traffic/traffic2.png'),
        },
        {
          title: 'Recursos abundantes',
          desc: 'Incluye recursos didácticos completos, como PPT y guías de 12 clases, además de videos de ensamblaje y materiales de apoyo para los cursos por proyectos.',
          image: require('@/assets/product/traffic/traffic3.png'),
        },
      ],
      intro: {
        title: 'Introducción del producto',
        desc: 'El kit de transporte inteligente para primaria y secundaria toma como tema el “viaje inteligente” y la “seguridad vial”, combinando tecnologías como el control electrónico y los sensores, para guiar a los estudiantes a diseñar y construir por sí mismos sistemas de transporte inteligente, simular escenarios reales de tráfico y desarrollar su alfabetización científica y su capacidad de innovación.',
        bg: require('@/assets/product/traffic/banner1.png'),
      },
      course: {
        title: 'Cursos complementarios',
        desc: 'Incluye cursos basados en proyectos sobre percepción y control del tráfico, vinculación de señales, planificación de rutas y otros temas, adaptados a diferentes etapas y horarios.',
        image: require('@/assets/product/traffic/course.png'),
      },
      equipmentsTitle: 'Configuración de equipos',
      equipments: [
        {
          title: 'Tira de luces RGB',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'Módulo de reloj DS1307',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'Sensor de temperatura y humedad DHT11',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'Sensor de movimiento humano',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'Módulo de iluminación LED',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'Módulo de ventilador',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'Interruptor optoacoplador tipo ranura',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'Módulo de botón',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'Placa de control',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'Placa de expansión',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },
    banner: {
      alt: 'Banner de la página principal de productos',
      title: 'Productos y soluciones Zetok',
      description:
        'Integración de kits, cursos, equipos y software, compatible con el aprendizaje basado en proyectos',
      image: 'https://picsum.photos/id/1069/1600/900',
    },
    courses: {
      banner: {
        alt: 'Banner del módulo de cursos',
        title: 'Cuatro grandes sistemas de cursos',
        description:
          'El contenido de los cursos abarca múltiples áreas disciplinarias como ciencia, tecnología, ingeniería, arte y matemáticas (STEAM), promoviendo la integración y aplicación del conocimiento interdisciplinario de los estudiantes.',
        image: require('@/assets/product/courses/banner.png'),
      },
      design: {
        title: 'Conozca nuestros cursos destacados',
        nav: [
          'Edad 3-6 años',
          'Edad 6-12 años',
          'Edad 8-13 años',
          'Edad 9-15 años',
        ],
        entries: [
          {
            title: 'Sistema de exploración científica · Infantil (6 cursos)',
            desc: 'A través de fenómenos comunes en la vida cotidiana, utilizando material didáctico científico para profundizar en la exploración y comprender las leyes y principios del desarrollo de las cosas.',
            image: require('@/assets/product/courses/courses1.png'),
          },
          {
            title: 'Sistema Maker STEAM para jóvenes (3 cursos)',
            desc: 'Desarrolla la creatividad personal, permite utilizar equipos, practicar de manera activa y convertir las ideas en obras.',
            image: require('@/assets/product/courses/courses2.png'),
          },
          {
            title: 'Sistema de cursos de corte láser (3 cursos)',
            desc: 'Permite utilizar equipos para cortar distintas piezas estructurales, ensamblarlas en estructuras tridimensionales y decorarlas. Capacidad de programación: comprender la lógica y los principios del juicio en programación.',
            image: require('@/assets/product/courses/courses3.png'),
          },
          {
            title: 'Sistema de cursos de inteligencia artificial (4 cursos)',
            desc: 'Utiliza herramientas y equipos para diseñar y fabricar la apariencia de los trabajos, y mediante programación hacerlos inteligentes, simplificados y capaces de resolver problemas de la vida cotidiana. ',
            image: require('@/assets/product/courses/courses4.png'),
          },
        ],
        detailsTitle: 'Ventajas del curso',
        details: [
          {
            title: 'Fuerte componente práctico',
            description: 'Aprender haciendo, de la teoría a la habilidad',
            image: require('@/assets/product/courses/icon1.png'),
          },
          {
            title: 'Desarrollo del pensamiento innovador',
            description: 'Diseño práctico, resolución creativa de problemas',
            image: require('@/assets/product/courses/icon2.png'),
          },
          {
            title: 'Aprendizaje impulsado por proyectos',
            description:
              'Aprender mediante proyectos y dominar el conocimiento en la práctica',
            image: require('@/assets/product/courses/icon3.png'),
          },
          {
            title: 'Exploración de la vanguardia tecnológica',
            description:
              'Seguir las tendencias tecnológicas y aprender la aplicación de kits inteligentes',
            image: require('@/assets/product/courses/icon4.png'),
          },
          {
            title: 'Enseñanza sistematizada',
            description:
              'El contenido del curso progresa de lo simple a lo complejo, desde la teoría básica hasta la práctica operativa',
            image: require('@/assets/product/courses/icon5.png'),
          },
          {
            title: 'Equilibrio entre diversión y desafío',
            description:
              'La diversión despierta el interés, el desafío potencia el talento y el crecimiento se logra mediante la exploración. ',
            image: require('@/assets/product/courses/icon6.png'),
          },
        ],
      },
      ai: {
        title: 'Serie de cursos de inteligencia artificial',
        items: [
          {
            name: 'Granja inteligente',
            image: require('@/assets/product/courses/courses5.png'),
          },
          {
            name: 'Hogar inteligente',
            image: require('@/assets/product/courses/courses6.png'),
          },
          {
            name: 'Transporte inteligente',
            image: require('@/assets/product/courses/courses7.png'),
          },
          {
            name: 'Fábrica inteligente',
            image: require('@/assets/product/courses/courses8.png'),
          },
        ],
      },
      aiBanner: {
        alt: 'Banner del curso de IA',
        text: 'Aprendizaje impulsado por proyectos, integración interdisciplinaria, desarrollo de habilidades prácticas, cooperación y resolución de problemas. Seguridad y personalización como prioridades, la exhibición de resultados refuerza el sentido de logro y acompaña el crecimiento de los estudiantes.',
        image: require('@/assets/product/courses/banner1.png'),
      },
    },

    laser: {
      banner: {
        alt: 'Productos láser',
        title: 'Productos Láser Good Laser',
        description:
          'Equipos y soluciones de corte y grabado láser seguros y fáciles de usar para entornos educativos',
        image: require('@/assets/product/laser/banner.png'),
      },
      advantagesTitle: 'Nuestras ventajas',
      extraNote: {
        light640_640:
          'Excelentes resultados de corte y grabado\nMúltiples modelos con diferentes opciones de potencia láser para satisfacer diversas necesidades de aplicación\nTipo de láser: CO2 DC  Potencia del láser: 60W–130W',
      },
      center: {
        title: 'Centro de productos',
        laser_accessories: 'Accesorios láser',
        air_purifier_name: 'Purificador de aire',
        description:
          'Ofrecemos soluciones de equipos láser adaptadas a los diferentes niveles de enseñanza de las escuelas. Zetok ha lanzado cuatro soluciones oficiales de equipos láser, entre las cuales las escuelas pueden elegir según sus necesidades reales de enseñanza.',
        tabs: [
          {
            key: 'light530',
            label: 'Light 530',
            images: [
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Láser de alta calidad y alta precisión',
                bgColor: '#4285F4',
                description:
                  'Tubo láser de CO₂ engrosado y de alta calidad con una longitud de onda de 10640 nm, que ofrece 55 W de láser CO₂ de alta calidad. Espesor máximo de corte de hasta 20 mm (acrílico), velocidad de trabajo de hasta 600 mm/s y precisión de repetición de 0,025 mm, ideal para el corte y grabado rápido y preciso de obras creativas finas.',
                image: require('@/assets/product/laser/light530-1.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title:
                  'Sistema de filtrado de gases de escape integrado de tres etapas',
                bgColor: '#FFBC0C',
                description:
                  'Diseño integrado con filtro, carbón activado y capa de ozono UV para la filtración de humo y polvo. Más limpio y ecológico, además de ahorrar espacio y ser compacto, sin necesidad de una caja de filtrado adicional.',
                image: require('@/assets/product/laser/light530-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Máxima prioridad en los estándares de seguridad',
                bgColor: '#34A853',
                description:
                  'Ha superado las pruebas de seguridad más exigentes de un laboratorio SGS, producto láser de Clase I certificado por la FDA. Diseño exclusivo con indicadores de estado de seguridad y funcionamiento para una supervisión clara y directa del estado de la máquina.',
                image: require('@/assets/product/laser/light530-3.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Operación sencilla y potente sistema de corte láser',
                bgColor: '#0F9D58',
                description:
                  '· Parámetros de procesamiento ajustables según el material (corte, grabado profundo, grabado superficial, escaneo, etc.). · Amplias plantillas que aumentan la eficiencia del diseño. · La cámara admite posicionamiento preciso para la asistencia al diseño, haciendo realidad las ideas creativas.',
                image: require('@/assets/product/laser/light530-4.png'),
              },
            ],
          },
          {
            key: 'light640',
            label: 'Light 640',
            images: [
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
            ],
            models: [
              {
                key: '640',
                label: 'Light 640',
                image: require('@/assets/product/laser/640.png'),
              },
              {
                key: '960',
                label: 'Light 960',
                image: require('@/assets/product/laser/960.png'),
              },
              {
                key: '1390',
                label: 'Light 1390',
                image: require('@/assets/product/laser/1390.png'),
              },
              {
                key: '1610',
                label: 'Light 1610',
                image: require('@/assets/product/laser/1610.png'),
              },
            ],
            modelAdvantages: {
              640: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Área de trabajo',
                  bgColor: '#4285F4',
                  description: `Light640 (600*400mm)
Light960 (900*600mm)
<br>Light1390 (1300*900mm)
<br>Light1610 (1600*1000mm)`,
                  image: require('@/assets/product/laser/640-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title:
                    'Autoenfoque eficiente + posicionamiento por punto rojo',
                  bgColor: '#FFBC0C',
                  description:
                    'La función de autoenfoque permite un enfoque rápido y preciso antes del corte y grabado. En combinación con el posicionamiento por punto rojo, la posición de trabajo puede mostrarse en tiempo real, ahorrando tiempo y ofreciendo mejores resultados.',
                  image: require('@/assets/product/laser/640-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Diseño trasero abierto',
                  bgColor: '#34A853',
                  description:
                    'El diseño trasero abierto permite la introducción de materiales de longitud ilimitada. Placas de 600 mm × longitud ilimitada hacen el trabajo más cómodo y menos restringido.',
                  image: require('@/assets/product/laser/640-3.png'),
                },
              ],
              960: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Excelentes resultados de corte y grabado',
                  bgColor: '#4285F4',
                  description:
                    'El cortador láser está equipado con una amplia plataforma de trabajo y alcanza una precisión y eficiencia de nivel industrial en el procesamiento de madera y acrílico. Ideal para la producción en serie de trabajos láser de alta calidad.',
                  image: require('@/assets/product/laser/960-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title:
                    'Tubo láser de alta calidad y componentes de precisión',
                  bgColor: '#FFBC0C',
                  description:
                    'Variadas líneas de productos permiten seleccionar diferentes tipos de láser y velocidades de procesamiento para satisfacer diversas necesidades de producción.',
                  image: require('@/assets/product/laser/960-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title:
                    'Estricto control de calidad del haz y garantía de calidad',
                  bgColor: '#34A853',
                  description:
                    'Pruebas rigurosas, guiado preciso del haz y más de cinco pruebas de corte y grabado garantizan un rendimiento láser estable y uniforme de los tubos láser de CO₂ de alta calidad.',
                  image: require('@/assets/product/laser/960-3.png'),
                },
              ],
              1390: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Funciones de seguridad completas y avanzadas',
                  bgColor: '#4285F4',
                  description: `1. Parada de emergencia
<br>2. Luz de alarma
<br>3. Interruptor impermeable
<br>4. Cable de puesta a tierra
<br>5. Alarma integrada del sensor térmico
<br>6. Protección abatible
<br>7. Ventana de vidrio protector templado`,
                  image: require('@/assets/product/laser/1390-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Duradero y de calidad excepcional',
                  bgColor: '#FFBC0C',
                  description: `1. Ideal para proyectos individuales o producción en masa.
<br>2. Amplia gama de áreas de trabajo de 600 x 400 mm a 1600 x 1000 mm.
<br>3. Velocidad de grabado inigualable.
<br>4. Desarrollado por expertos de la industria.
<br>5. Ideal para personalización, educación e industria.`,
                  image: require('@/assets/product/laser/1390-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title:
                    'Optimización de la producción mediante supervisión inteligente',
                  bgColor: '#34A853',
                  description:
                    'Diseñado especialmente para proteger componentes sensibles (ejes, cabezal láser, óptica, lentes) del polvo y la suciedad, garantizando un funcionamiento estable durante años incluso bajo uso intensivo.',
                  image: require('@/assets/product/laser/1390-3.png'),
                },
              ],
              1610: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title:
                    'Autoenfoque eficiente + posicionamiento por punto rojo',
                  bgColor: '#4285F4',
                  description:
                    'La función de autoenfoque permite un enfoque rápido y preciso antes del corte y grabado. Con el posicionamiento por punto rojo, la posición de trabajo se muestra en tiempo real, lo que aumenta significativamente la eficiencia.',
                  image: require('@/assets/product/laser/1610-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Excelentes resultados de corte y grabado',
                  bgColor: '#FFBC0C',
                  description:
                    'Amplia plataforma de corte con precisión de nivel industrial para madera y acrílico, ideal para la producción en serie de trabajos láser de alta calidad.',
                  image: require('@/assets/product/laser/1610-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Duradero y de calidad excepcional',
                  bgColor: '#34A853',
                  description: `1. Ideal para proyectos individuales o producción en masa.
<br>2. Amplia gama de áreas de trabajo.
<br>3. Velocidad de grabado inigualable.
<br>4. Desarrollado por expertos de la industria.
<br>5. Ideal para personalización, educación e industria.`,
                  image: require('@/assets/product/laser/1610-3.png'),
                },
              ],
            },
          },
          {
            key: 'lightblue530',
            label: 'Light Blue 530',
            images: [
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Grabador de luz azul portátil',
                bgColor: '#4285F4',
                description:
                  'Diseño moderno y compacto, adecuado para el hogar, escuelas o estudios. Carcasa metálica con cubierta acrílica, perfecta para escritorio y con potente rendimiento de 20W para un corte eficiente.',
                image: require('@/assets/product/laser/blue530-1.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Procesamiento cerrado para evitar lesiones',
                bgColor: '#FFBC0C',
                description:
                  'Diseño completamente cerrado: si la tapa se abre durante el funcionamiento, el equipo se detiene automáticamente. Interruptor de parada de emergencia para máxima seguridad, ideal para el hogar y la escuela.',
                image: require('@/assets/product/laser/blue530-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Procesamiento multimaterial',
                bgColor: '#34A853',
                description:
                  'Admite el procesamiento de más de cien materiales. Ampliable con accesorios para objetos cilíndricos o redondos, ideal para pequeñas empresas.',
                image: require('@/assets/product/laser/blue530-3.png'),
              },
            ],
          },
          {
            key: 'markm20',
            label: 'Mark M20',
            images: [
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Amplios escenarios de aplicación',
                bgColor: '#4285F4',
                description:
                  'Adecuado para grabado de joyería, objetos personalizados, marcado de piezas y mucho más, desde joyas y frascos de perfume hasta pequeñas placas industriales.',
                image: require('@/assets/product/laser/m20.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Aplicaciones innovadoras en el ámbito educativo',
                bgColor: '#FFBC0C',
                description:
                  'Mark M20 lleva la precisión industrial al ámbito educativo, apoyando la formación desde habilidades básicas de marcado hasta proyectos complejos.',
                image: require('@/assets/product/laser/m20-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Compacto y moderno',
                bgColor: '#34A853',
                description:
                  'Diseño compacto y moderno con bajo consumo de espacio, bajo nivel de ruido y gran ventana de visualización, ideal para instituciones educativas y comercios.',
                image: require('@/assets/product/laser/m20-3.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Marcado en cuestión de segundos',
                bgColor: '#0F9D58',
                description:
                  'Incluso las fuentes más pequeñas se marcan con precisión en cuestión de segundos. En combinación con el software LightMaker, la productividad aumenta considerablemente.',
                image: require('@/assets/product/laser/m20-4.png'),
              },
            ],
          },
          {
            key: 'accessories',
            label: 'Accesorios',
            images: [
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
            ],
            advantages: [
              {
                description: `
· Lugares de uso: Adecuado para todos los entornos con humo, olores, polvo y gases tóxicos o nocivos.
<br>· Ámbitos de aplicación: Electrónica, fabricación de juguetes, metal de precisión, medicina, etc.
<br>· Característica de diseño: Diseño de puesto de trabajo simple o doble variable.
<br>· Sistema de filtrado: Sistema de filtrado multicapa.
<br>· Regulación del caudal de aire: Ajuste continuo según el volumen de gases.
<br>· Rendimiento de purificación: Tasa de limpieza de hasta el 99,97 %.
<br>· Descarga de aire: El aire purificado puede liberarse directamente en el interior。
`,
                image: require('@/assets/product/laser/accessories1.png'),
              },
              {
                description: `· Tipo de equipo: Dispositivo auxiliar para máquinas de corte/grabado láser.
<br>· Finalidad: Realización de la rotación de las piezas de trabajo.
<br>· Objetos adecuados: Objetos cilíndricos y tubulares.
<br>· Ampliación: Permite procesar cilindros en lugar de solo placas planas.`,
                image: require('@/assets/product/laser/accessories2.png'),
              },
              {
                description: `
· Máquina formadora eficiente para un conformado preciso.
<br>· Control CNC para una operación sencilla.
<br>· Diversas herramientas de conformado disponibles.
<br>· Sistema de sujeción rápida para aumentar la eficiencia.
<br>· Dispositivos de seguridad completos.
<br>· Adecuada para la conformación de diferentes materiales。`,
                image: require('@/assets/product/laser/accessories3.png'),
              },
            ],
          },
        ],
      },
    },

    support: {
      afterSales: {
        banner: {
          alt: 'Banner de descargas de tutoriales',
          title: 'Descarga de tutoriales',
          image: require('@/assets/after/banner.png'),
        },
        downloadText: 'Descargar tutorial',
        items: [
          {
            id: 'mk-1',
            name: 'Granja inteligente',
            image: 'https://picsum.photos/seed/as-farm1/588/391',
            link: '#',
          },
          {
            id: 'mk-2',
            name: 'Hogar inteligente',
            image: 'https://picsum.photos/seed/as-home1/588/391',
            link: '#',
          },
          {
            id: 'mk-3',
            name: 'Transporte inteligente',
            image: 'https://picsum.photos/seed/as-traffic1/588/391',
            link: '#',
          },
          {
            id: 'mk-4',
            name: 'Fábrica inteligente',
            image: 'https://picsum.photos/seed/as-factory1/588/391',
            link: '#',
          },
          {
            id: 'mk-5',
            name: 'Espacio Maker',
            image: 'https://picsum.photos/seed/as-makerspace1/588/391',
            link: '#',
          },
          {
            id: 'mk-6',
            name: 'Cursos de robótica',
            image: 'https://picsum.photos/seed/as-robot1/588/391',
            link: '#',
          },
          {
            id: 'mk-7',
            name: 'Tutoriales de IA',
            image: 'https://picsum.photos/seed/as-ai1/588/391',
            link: '#',
          },
          {
            id: 'mk-8',
            name: 'Tutoriales de IoT',
            image: 'https://picsum.photos/seed/as-iot1/588/391',
            link: '#',
          },
        ],
      },
    },
  },
};
